module.exports = __webpack_public_path__ + "img/banckMoney.f7914a88.png";